import React from 'react'
import PropTypes from 'prop-types'

import { InnerHtml, ImageDiv } from '../global'

/**
 * A component for various types of paragraphs in post flex content
 *
 * @param {string} props.header - Optional paragraph heading
 * @param {string} props.size- Enum: 'regular' | 'large' | 'image'
 * @param {string} props.content - paragraph's content including html tags. Use InnerHtml component.
 * @param {Object} props.image - Optional Image - { altText, sourceUrl, description }
 * @param {any} props.rest - Used to add e.g. inline style or key
 *
 * @returns {JSX.Element} Renders paragraph with correct layout & content
 */

const PostParagraph = ({ header, size, content, image, ...rest }) => {
  if (!content) return null

  return (
    <div className={`post-paragraph ${size}`} {...rest}>
      {header && <h3 className="ingress">{header}</h3>}
      <InnerHtml className={`post-paragraph__${size}`} content={content} />
      {size === 'image' && image?.sourceUrl && (
        <div className="pg-image">
          <ImageDiv
            className="pg-image__img"
            src={image.sourceUrl}
            alt={image.altText}
          />
          <InnerHtml className="image-caption" content={image.description} />
        </div>
      )}
    </div>
  )
}

PostParagraph.propTypes = {
  header: PropTypes.string,
  size: PropTypes.oneOf(['regular', 'large', 'image']),
  content: PropTypes.string,
  image: PropTypes.shape({
    altText: PropTypes.string,
    sourceUrl: PropTypes.string,
    description: PropTypes.string,
  }),
  rest: PropTypes.any,
}

export default PostParagraph
